import React, { useRef, useEffect } from 'react';
import MessageItem from './MessageItem';
import CustomScrollBar from '../../../../../components/CustomScrollBar';
import './scrollBarStyles.scss';
import { useTheme } from 'styled-components';

const MessageList = props => {
  const { messages, navigation, setActiveMessage, highlightedMessageId } = props;
  const { MessageList } = useTheme();

  const highlightedRef = useRef(null);
  const hasScrolledRef = useRef(false);

  useEffect(() => {
    if (highlightedRef.current && !hasScrolledRef.current) {
      hasScrolledRef.current = true;
      setTimeout(() => {
        highlightedRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 500);
    }
  }, [messages, highlightedMessageId]);

  return (
    <CustomScrollBar
      customClassNames="custom-scrollbar-message-list"
      containerStyle={{
        marginTop: '2rem',
        width: '95%',
        height: '100%',
      }}
      customStyle={MessageList.ScrollBarCustomStyle}
    >
      {messages
        ?.filter(message => !message?.deleted)
        .map(filteredMessage => {
          const isHighlighted =
            highlightedMessageId?.toString() === filteredMessage.message_id?.toString() &&
            filteredMessage.message_read !== 'yes';

          return (
            <MessageItem
              key={filteredMessage.message_id}
              message={filteredMessage}
              messageDetailsHandle={setActiveMessage}
              navigation={navigation}
              highlighted={isHighlighted}
              highlightedRef={isHighlighted ? highlightedRef : null}
              {...props}
            />
          );
        })}
    </CustomScrollBar>
  );
};

export default MessageList;
